export default {
  successPopup: {
    title: 'Registration completed successfully!',
    description: 'A letter with a password has been sent to your specified e-mail address.',
    button: 'Login'
  },
  emailTaken: 'The email address is already used by another account.',
  hasAccount: 'Already have an account?',
  registration: 'Registration',
  agreeWithPrivacyPolicy: 'I agree with',
  agreeWithPrivacyPolicyLink: 'privacy policy',
  notSelected: '- not selected -',
  additionalInfo: 'Additional Information',
  specialisationNotSelected: '- no specialization selected -',
  maybeSpam: 'Didn\'t find the email?<br>Most likely, it got into the "Spam" folder.',
  success: 'Success',
  instructions: 'We sent an email with the password <br>to Your email address',
  bim: '© BIMLIB LLC',
  agreement: 'TERMS OF USE',
  privacyPolicy: 'PRIVACY POLICY',
  back: 'Back',
  next: 'Next',
  skip: 'Skip',
  step: 'step',
  of: 'of',
  acceptAccount: 'Account is confirmed',
  redirectText: 'The BIMLIB team wishes you a good mood:) Redirect to the main page via…',
  goNow: 'Go Now',
  emailConfirmed: 'Email confirmed',
  continue: 'Continue',
  createAccount: 'Create account',
  mobilePhone: 'Mobile phone',
  selectRole: 'Select role',
  selectUserRole: 'User role',
  manufacturer: 'Manufacturer',
  designer: 'Designer',
  company: 'Company',
  estimator: 'Estimator',
  departmentEngineer: 'Purchasing department manager',
  headMTO: 'Head of MTO/PTO',
  director: 'Head of the Technical (Engineering) Department',
  expert: 'Expert',
  customRole: 'Enter you role',
  noCompany: 'No company',
  uploadImg: 'Drag-n-drop the image or click on an area',
  uploadTitle: 'Upload the image',
  uploadDesc: 'Max. 2.5 MB, minimum resolution (150x150), format: .jpeg, .jpg,. png',
  buttons: {
    add: 'Add',
    save: 'Save',
    accept: 'Accept',
    cancel: 'Cancel',
    remove: 'Remove',
    link: 'Link',
    import: 'Import',
    continue: 'Continue',
    skip: 'Skip',
    finish: 'Finish'
  },
  other: 'Other',
  welcome: 'Welcome!',
  welcomeDesc: 'To complete the registration, write the name in the text box below, the rest of the fields can be ignored, but there are really useful things there.',
  whoaYou: 'Introduce yourself',
  name: 'Name',
  lastName: 'Last name',
  setAvatar: 'Set an avatar',
  uploadSelf: 'Upload avatar',
  setPassword: 'Set password',
  passwordDesc: 'Warning! It is not save to store a password in e-mail, so we recommend you to come up with your own. Be sure to write it down as after confirmation the old one will be inactive.',
  password: 'Password',
  retryPassword: 'Retry password',
  goodPassword: 'Good password contains:',
  pswd1: 'min 8 characters',
  pswd2: 'a number or special character ($ % @ _ .)',
  pswd3: 'no duplicate characters',
  delicious: 'Great!',
  deliciousDesc: 'We are looking forward our service usage will bring you only positive emotions.',
  youCan: 'Now you can:',
  can1: 'Publish models in the library on a par with 350+ other manufacturers',
  can2: 'Create articles for the Reading Room with a functional editor',
  can3: 'View detailed statistics and learn about your visitors preferences',
  start: 'Start',
  specialisations: [
    'Architectural solutions',
    'Planning organization of the land plot',
    'Constructive decisions',
    'Water supply and sewerage systems',
    'Gas supply systems',
    'Heating, ventilation and air conditioning systems',
    'Communication, alarm and fire safety systems',
    'Power supply systems',
    'Organization of construction',
    'Technological solutions'
  ],
  roles: {
    manufacturer: 'Manufacturer',
    designer: 'Designer'
  }
}
